<div class="content-category-container" *ngIf="Object.values(data?.myBrand?.shares || {}).some(Boolean)">
  <ag-grid-angular id="content-category-distribution"
                   [ngClass]="
                        {
                          'collapsed': showingTopFive,
                          'expanded': !showingTopFive
                        }"
                   [rowData]="rowData"
                   [columnDefs]="colDef"
                   [theme]="theme"
                   [defaultColDef]="defaultColDef"
                   [gridOptions]="gridOptions"
  >
  </ag-grid-angular>
  <div class="button-container" *ngIf="showFullListButton">
    <button class="expand-button" (click)="toggleFullList()">{{ buttonText }}</button>
  </div>
</div>
<app-loader *ngIf="loading"></app-loader>
<div class="no-data-container" *ngIf="!Object.values(data?.myBrand?.shares || {}).some(Boolean) && !loading">
  <app-no-widget-data></app-no-widget-data>
</div>

